export default {
  availableLanguages: ['fr', 'en'],
  categories: [],
  templates: [],
  template: null,
  defaultLanguagesTemplates: {}
}
